
window.moment = require('moment')
require('angular-moment-picker')
require('bootstrap');
require("angucomplete-alt");
require("checklist-model");
require("angular-drag-and-drop-lists");
require('ng-currency');
require('uuid-js');

module.exports = require('angular').module('app.deps', [
  require('ng-dialog'),
  require('ng-file-upload'),
  require('angular-google-analytics').name,
  require('ng-csv'),
  'checklist-model',
  'moment-picker',

  require("angular-sanitize"),
  require("angular-messages"),
  require("angular-animate"),
  require('angular-credit-cards'),

  "dndLists",
  "angucomplete-alt",
  "720kb.socialshare",
  "ng-currency",

  require("./filters/rr-camel-to-title-case").name,
  require("./filters/linkify").name
])
.config(['momentPickerProvider', function (momentPickerProvider) {
      momentPickerProvider.options({
          minutesFormat: 'HH:mm'
      });
  }]);
